function getJsonUrl(){
    return "/content/json/";

}

export async function loadDataVehicles() {
    try {
        const response = await fetch(getJsonUrl() + "vehicles.json");
        return await response.json();
    } catch (error) {
        console.error('Error fetching JSON:', error);
        return false;
    }
}

export async function loadRegionData() {
    try {
        const response = await fetch(getJsonUrl() + "regions.json");
        return await response.json();
    } catch (error) {
        console.error('Error fetching JSON:', error);
        return false;
    }
}
export async function loadRibbonColours() {
    const keyMap = {
        savings: 'vehicle-landing-page.ribbon-color-savings',
        savingsHighlight: 'vehicle-landing-page.ribbon-color-savings-highlight',
        express: 'vehicle-landing-page.ribbon-color-express',
        expressHighlight: 'vehicle-landing-page.ribbon-color-express-highlight',
        expressText: 'vehicle-landing-page.ribbon-text-express'
    };


    const keys = Object.values(keyMap);
    const params = new URLSearchParams();
    keys.forEach(k => params.append('keys[]', k));

    const response = await fetch(`/api/v1/getOptions?${params}`);
    const data = await response.json();

    const ribbonData = {};
    Object.entries(keyMap).forEach(([shortKey, fullKey]) => {
        ribbonData[shortKey] = data[fullKey];
    });

    return ribbonData;
}
